export default __webpack_public_path__ + "static/media/covid.b6734101.png";